(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mobile-purchase-bar"] && !Shopify.designMode) return;
  try {
    (() => {
    const bar = document.querySelector('[data-mobile-purchase-bar]');
    if (!bar || bar.dataset.initialized === 'true') return;

    bar.dataset.initialized = 'true';

    const mobileQuery = window.matchMedia('(max-width: 749px)');
    const controlSlot = bar.querySelector('[data-mobile-purchase-bar-control]');
    const placeholder = bar.querySelector('[data-mobile-purchase-bar-placeholder]');
    const changeButton = bar.querySelector('[data-mobile-purchase-bar-change]');
    const summary = bar.querySelector('[data-mobile-purchase-bar-summary]');
    const variant = bar.querySelector('[data-mobile-purchase-bar-variant]');
    const status = bar.querySelector('[data-mobile-purchase-bar-status]');
    const labels = {
      change: bar.dataset.labelChange,
      loading: bar.dataset.labelLoading,
      selected: bar.dataset.labelSelected,
      soldOut: bar.dataset.labelSoldOut,
      unitOne: bar.dataset.labelUnitOne,
      unitOther: bar.dataset.labelUnitOther,
      exVat: bar.dataset.labelExVat,
    };

    let active = false;
    let authority = null;
    let unsubscribe = null;
    let sourceSnapshot = null;
    let decoratedControl = null;
    let decoratedControlState = null;
    let decoratedHost = null;
    let decoratedHostHadClass = false;
    let resizeObserver = null;

    const cartDrawer = () => document.querySelector('cart-drawer');
    const formatQuantity = (value) => {
      const numericValue = Number(value);
      if (!Number.isFinite(numericValue)) return String(value || '').trim();
      return new Intl.NumberFormat(document.documentElement.lang || 'en-GB').format(numericValue);
    };
    const quantityText = (value) => {
      const formatted = formatQuantity(value);
      return `${formatted} ${Number(value) === 1 ? labels.unitOne : labels.unitOther}`;
    };
    const isCartOpen = () => {
      const drawer = cartDrawer();
      return Boolean(
        drawer &&
          (drawer.classList.contains('active') ||
            drawer.hasAttribute('open') ||
            drawer.getAttribute('aria-hidden') === 'false'),
      );
    };
    const sourceAuthority = (snapshot) =>
      snapshot?.provider === 'hulk' || snapshot?.provider === 'native'
        ? snapshot.provider
        : snapshot?.authority;
    const styleProperties = [
      '--mobile-purchase-control-bottom',
      '--mobile-purchase-control-left',
      '--mobile-purchase-control-width',
      '--mobile-purchase-control-height',
      'visibility',
      'pointer-events',
    ];
    const captureStyles = (element) =>
      Object.fromEntries(
        styleProperties.map((property) => [
          property,
          {
            value: element.style.getPropertyValue(property),
            priority: element.style.getPropertyPriority(property),
          },
        ]),
      );
    const restoreStyles = (element, styles) => {
      styleProperties.forEach((property) => {
        const original = styles[property];
        if (original.value) element.style.setProperty(property, original.value, original.priority);
        else element.style.removeProperty(property);
      });
    };
    const findProductFormHost = (form) => {
      let candidate = form?.parentElement || null;
      while (candidate && candidate !== document.body) {
        if (candidate.tagName === 'PRODUCT-FORM') return candidate;
        candidate = candidate.parentElement;
      }
      return null;
    };
    const restoreHost = () => {
      if (decoratedHost && !decoratedHostHadClass) {
        decoratedHost.classList.remove('mobile-purchase-bar__native-host');
      }
      decoratedHost = null;
      decoratedHostHadClass = false;
    };
    const restoreControl = () => {
      restoreHost();
      controlSlot.classList.remove('is-ready');

      if (!decoratedControl || !decoratedControlState) return;

      if (decoratedControlState.forcedDisabled) {
        decoratedControl.disabled = decoratedControlState.originalDisabled;
      }
      if (decoratedControlState.contentChanged) {
        decoratedControl.innerHTML = decoratedControlState.originalContent;
      }

      decoratedControl.classList.toggle(
        'mobile-purchase-bar__real-add',
        decoratedControlState.hadRealAddClass,
      );
      if (decoratedControlState.mobilePurchaseSource === null) {
        delete decoratedControl.dataset.mobilePurchaseSource;
      } else {
        decoratedControl.dataset.mobilePurchaseSource = decoratedControlState.mobilePurchaseSource;
      }
      restoreStyles(decoratedControl, decoratedControlState.styles);

      if (decoratedControlState.describedBy === null) decoratedControl.removeAttribute('aria-describedby');
      else decoratedControl.setAttribute('aria-describedby', decoratedControlState.describedBy);

      decoratedControl = null;
      decoratedControlState = null;
    };
    const setBarSource = (snapshot) => {
      bar.dataset.mobilePurchaseProvider = snapshot?.provider || 'pending';
      const resolvedAuthority = sourceAuthority(snapshot);
      if (resolvedAuthority) bar.dataset.mobilePurchaseAuthority = resolvedAuthority;
      else delete bar.dataset.mobilePurchaseAuthority;
    };
    const positionControl = () => {
      if (!decoratedControl || !active || !mobileQuery.matches) return;

      const rect = controlSlot.getBoundingClientRect();
      const barRect = bar.getBoundingClientRect();
      const bottomOffset = Math.max(0, barRect.bottom - rect.bottom);
      decoratedControl.style.setProperty('--mobile-purchase-control-bottom', `${bottomOffset}px`);
      decoratedControl.style.setProperty('--mobile-purchase-control-left', `${rect.left}px`);
      decoratedControl.style.setProperty('--mobile-purchase-control-width', `${rect.width}px`);
      decoratedControl.style.setProperty('--mobile-purchase-control-height', `${rect.height}px`);
      decoratedControl.style.setProperty('visibility', bar.hidden ? 'hidden' : 'visible');
      decoratedControl.style.setProperty('pointer-events', bar.hidden ? 'none' : 'auto');
    };
    const updateVisibility = () => {
      if (!active || !mobileQuery.matches) return;
      bar.hidden = isCartOpen();
      positionControl();
    };
    const decorateControl = (snapshot) => {
      if (!snapshot.control) {
        restoreControl();
        return false;
      }
      if (decoratedControl !== snapshot.control) {
        restoreControl();
        decoratedControl = snapshot.control;
        decoratedControlState = {
          describedBy: decoratedControl.getAttribute('aria-describedby'),
          originalDisabled: decoratedControl.disabled,
          originalContent: decoratedControl.innerHTML,
          forcedDisabled: false,
          contentChanged: false,
          hadRealAddClass: decoratedControl.classList.contains('mobile-purchase-bar__real-add'),
          mobilePurchaseSource: decoratedControl.dataset.mobilePurchaseSource ?? null,
          styles: captureStyles(decoratedControl),
        };
        decoratedControl.classList.add('mobile-purchase-bar__real-add');
        decoratedControl.setAttribute('aria-describedby', status.id);
      }
      decoratedControl.dataset.mobilePurchaseSource = sourceAuthority(snapshot);

      if (snapshot.disabled && !decoratedControl.disabled) {
        decoratedControl.disabled = true;
        decoratedControlState.forcedDisabled = true;
        if (sourceAuthority(snapshot) === 'hulk') {
          decoratedControl.textContent = labels.soldOut;
          decoratedControlState.contentChanged = true;
        }
      } else if (!snapshot.disabled && decoratedControlState.forcedDisabled) {
        decoratedControl.disabled = decoratedControlState.originalDisabled;
        decoratedControlState.forcedDisabled = false;
        if (decoratedControlState.contentChanged) {
          decoratedControl.innerHTML = decoratedControlState.originalContent;
          decoratedControlState.contentChanged = false;
        }
      }

      if (sourceAuthority(snapshot) === 'native' && snapshot.form) {
        const nextHost = findProductFormHost(snapshot.form);
        if (nextHost !== decoratedHost) {
          restoreHost();
          decoratedHost = nextHost;
          decoratedHostHadClass = Boolean(
            decoratedHost?.classList.contains('mobile-purchase-bar__native-host'),
          );
          decoratedHost?.classList.add('mobile-purchase-bar__native-host');
        }
      } else {
        restoreHost();
      }

      controlSlot.classList.add('is-ready');
      window.requestAnimationFrame(positionControl);
      return true;
    };
    const renderLoading = (snapshot = null) => {
      restoreControl();
      sourceSnapshot = snapshot;
      setBarSource(snapshot);
      updateVisibility();
      summary.textContent = labels.loading;
      variant.hidden = true;
      changeButton.hidden = true;
      placeholder.querySelector('span').textContent = labels.loading;
      status.textContent = labels.loading;
    };
    const renderError = (snapshot) => {
      restoreControl();
      sourceSnapshot = snapshot;
      setBarSource(snapshot);
      updateVisibility();
      const message = snapshot.disabledReason || labels.loading;
      summary.textContent = message;
      variant.hidden = true;
      changeButton.hidden = true;
      placeholder.querySelector('span').textContent = message;
      status.textContent = message;
    };
    const renderResolved = (snapshot) => {
      sourceSnapshot = snapshot;
      setBarSource(snapshot);
      updateVisibility();

      variant.textContent = snapshot.variantLabel || '';
      variant.hidden = !snapshot.variantLabel;

      const selectedQuantity = snapshot.quantity == null ? '' : quantityText(snapshot.quantity);
      summary.textContent = snapshot.totalPriceText
        ? `${selectedQuantity} · ${snapshot.totalPriceText} ${labels.exVat}`
        : selectedQuantity;
      changeButton.hidden = !snapshot.multiple;
      changeButton.textContent = labels.change;
      status.textContent = `${selectedQuantity}${snapshot.totalPriceText ? `, ${snapshot.totalPriceText} ${labels.exVat}` : ''} ${snapshot.disabled ? labels.soldOut : labels.selected}`;

      if (!decorateControl(snapshot)) {
        renderError({ ...snapshot, disabledReason: snapshot.disabledReason || labels.loading });
        return;
      }
      positionControl();
    };
    const renderSnapshot = (snapshot) => {
      if (!active || !mobileQuery.matches || !snapshot) return;
      if (snapshot.provider === 'pending') {
        renderLoading(snapshot);
        return;
      }
      if (snapshot.provider === 'error') {
        renderError(snapshot);
        return;
      }
      if (snapshot.provider === 'hulk' || snapshot.provider === 'native' || snapshot.provider === 'unavailable') {
        renderResolved(snapshot);
        return;
      }

      renderError({ ...snapshot, disabledReason: snapshot.disabledReason || labels.loading });
    };
    const bindAuthority = () => {
      const nextAuthority = window.PolyPouchPurchasingAuthority;
      if (!active || !nextAuthority || nextAuthority === authority) return;
      unsubscribe?.();
      authority = nextAuthority;
      unsubscribe = authority.subscribe(renderSnapshot);
    };
    const handleAuthorityReady = () => bindAuthority();
    const handleChange = () => {
      if (!sourceSnapshot?.multiple || !sourceSnapshot.optionRoot) return;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      sourceSnapshot.optionRoot.scrollIntoView({
        behavior: reduceMotion ? 'auto' : 'smooth',
        block: 'center',
      });
      window.setTimeout(
        () => sourceSnapshot?.focusTarget?.focus({ preventScroll: true }),
        reduceMotion ? 0 : 450,
      );
    };
    const observePresentation = () => {
      if ('ResizeObserver' in window) {
        resizeObserver = new ResizeObserver(() => {
          document.body.style.setProperty('--mobile-purchase-bar-height', `${bar.offsetHeight}px`);
          positionControl();
        });
        resizeObserver.observe(bar);
        resizeObserver.observe(controlSlot);
      }
    };
    const handleCartDrawer = () => {
      window.requestAnimationFrame(() => window.requestAnimationFrame(updateVisibility));
    };
    const activate = () => {
      if (active) return;
      active = true;
      bar.hidden = false;
      document.body.classList.add('mobile-purchase-bar-active');
      changeButton.addEventListener('click', handleChange);
      document.addEventListener('polypouch:purchasing-authority-ready', handleAuthorityReady);
      window.addEventListener('hulkapps-shipping-integration:cart-drawer', handleCartDrawer);
      observePresentation();
      renderLoading();
      bindAuthority();
    };
    const deactivate = () => {
      if (!active) return;
      active = false;
      sourceSnapshot = null;
      unsubscribe?.();
      unsubscribe = null;
      authority = null;
      resizeObserver?.disconnect();
      resizeObserver = null;
      changeButton.removeEventListener('click', handleChange);
      document.removeEventListener('polypouch:purchasing-authority-ready', handleAuthorityReady);
      window.removeEventListener('hulkapps-shipping-integration:cart-drawer', handleCartDrawer);
      document.body.classList.remove('mobile-purchase-bar-active');
      document.body.style.removeProperty('--mobile-purchase-bar-height');
      restoreControl();
      delete bar.dataset.mobilePurchaseProvider;
      delete bar.dataset.mobilePurchaseAuthority;
      summary.textContent = labels.loading;
      status.textContent = '';
      variant.textContent = '';
      variant.hidden = true;
      changeButton.hidden = true;
      placeholder.querySelector('span').textContent = labels.loading;
      bar.hidden = true;
    };
    const handleBreakpoint = () => {
      if (mobileQuery.matches) activate();
      else deactivate();
    };
    const handleSectionUnload = (event) => {
      if (!event.target.contains(bar)) return;
      deactivate();
      mobileQuery.removeEventListener('change', handleBreakpoint);
      document.removeEventListener('shopify:section:unload', handleSectionUnload);
    };

    mobileQuery.addEventListener('change', handleBreakpoint);
    document.addEventListener('shopify:section:unload', handleSectionUnload);
    handleBreakpoint();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sticky-pdp-buyButton"] && !Shopify.designMode) return;
  try {
    (() => {
    const bar = document.querySelector('[data-desktop-purchase-bar]');
    if (!bar || bar.dataset.initialized === 'true') return;

    bar.dataset.initialized = 'true';

    const desktopQuery = window.matchMedia('(min-width: 750px)');
    const button = bar.querySelector('[data-desktop-purchase-button]');
    const buttonLabel = bar.querySelector('[data-desktop-purchase-label]');
    const summary = bar.querySelector('[data-desktop-purchase-summary]');
    const status = bar.querySelector('[data-desktop-purchase-status]');
    const priceContainer = bar.querySelector('[data-desktop-purchase-price]');
    const unitPrice = bar.querySelector('[data-desktop-purchase-unit-price]');
    const unitPriceValue = bar.querySelector('[data-desktop-purchase-unit-price-value]');
    if (status?.id) button.setAttribute('aria-describedby', status.id);
    const labels = {
      loading: bar.dataset.labelLoading,
      orderNow: bar.dataset.labelOrderNow,
      selected: bar.dataset.labelSelected,
      soldOut: bar.dataset.labelSoldOut,
      unitOne: bar.dataset.labelUnitOne,
      unitOther: bar.dataset.labelUnitOther,
      exVat: bar.dataset.labelExVat,
    };

    let active = false;
    let authority = null;
    let unsubscribe = null;
    let renderedSnapshot = null;
    let submitting = false;
    let submittingTimer = null;

    const formatQuantity = (value) => {
      const numericValue = Number(value);
      if (!Number.isFinite(numericValue)) return String(value || '').trim();
      return new Intl.NumberFormat(document.documentElement.lang || 'en-GB').format(numericValue);
    };
    const quantityText = (value) => {
      const formatted = formatQuantity(value);
      return `${formatted} ${Number(value) === 1 ? labels.unitOne : labels.unitOther}`;
    };
    const setSourceAttributes = (snapshot) => {
      button.dataset.purchaseProvider = snapshot?.provider || 'pending';
      const resolvedAuthority =
        snapshot?.provider === 'hulk' || snapshot?.provider === 'native'
          ? snapshot.provider
          : snapshot?.authority;
      if (resolvedAuthority) button.dataset.purchaseSource = resolvedAuthority;
      else button.removeAttribute('data-purchase-source');
    };
    const applyButtonState = (disabled, label) => {
      button.disabled = disabled || submitting;
      buttonLabel.textContent = label;
      if (submitting) button.setAttribute('aria-busy', 'true');
      else button.removeAttribute('aria-busy');
    };
    const resetPricePresentation = () => {
      priceContainer.classList.remove('is-desktop-hulk-price');
      unitPrice.hidden = true;
      unitPriceValue.textContent = '';
    };
    const renderLoading = (snapshot = null) => {
      renderedSnapshot = snapshot;
      setSourceAttributes(snapshot);
      applyButtonState(true, labels.orderNow);
      summary.textContent = labels.loading;
      status.textContent = labels.loading;
      resetPricePresentation();
    };
    const renderError = (snapshot) => {
      renderedSnapshot = snapshot;
      setSourceAttributes(snapshot);
      const message = snapshot.disabledReason || labels.loading;
      applyButtonState(true, labels.orderNow);
      summary.textContent = message;
      status.textContent = message;
      resetPricePresentation();
    };
    const renderResolved = (snapshot) => {
      renderedSnapshot = snapshot;
      setSourceAttributes(snapshot);

      const variant = snapshot.variantLabel || '';
      const quantity = snapshot.quantity == null ? '' : quantityText(snapshot.quantity);
      const total = snapshot.totalPriceText ? `${snapshot.totalPriceText} ${labels.exVat}` : '';
      const selection = [variant, quantity, total].filter(Boolean).join(' · ');
      const unavailable = snapshot.provider === 'unavailable' || snapshot.disabled;

      summary.textContent = selection || snapshot.disabledReason || '';
      status.textContent = [selection, unavailable ? labels.soldOut : labels.selected].filter(Boolean).join(' ');
      if (snapshot.authority === 'hulk' && snapshot.unitPriceText) {
        unitPriceValue.textContent = snapshot.unitPriceText;
        unitPrice.hidden = false;
        priceContainer.classList.add('is-desktop-hulk-price');
      } else {
        resetPricePresentation();
      }
      applyButtonState(unavailable, unavailable ? labels.soldOut : labels.orderNow);
    };
    const renderSnapshot = (snapshot) => {
      if (!active || !desktopQuery.matches || !snapshot) return;
      if (snapshot.provider === 'pending') {
        renderLoading(snapshot);
        return;
      }
      if (snapshot.provider === 'error') {
        renderError(snapshot);
        return;
      }
      if (snapshot.provider === 'hulk' || snapshot.provider === 'native' || snapshot.provider === 'unavailable') {
        renderResolved(snapshot);
        return;
      }

      renderError({ ...snapshot, disabledReason: snapshot.disabledReason || labels.loading });
    };
    const clearPresentation = () => {
      renderedSnapshot = null;
      button.disabled = true;
      button.removeAttribute('aria-busy');
      button.removeAttribute('data-purchase-source');
      button.removeAttribute('data-purchase-provider');
      buttonLabel.textContent = labels.orderNow;
      summary.textContent = '';
      status.textContent = '';
      resetPricePresentation();
    };
    const bindAuthority = () => {
      const nextAuthority = window.PolyPouchPurchasingAuthority;
      if (!active || !nextAuthority || nextAuthority === authority) return;
      unsubscribe?.();
      authority = nextAuthority;
      unsubscribe = authority.subscribe(renderSnapshot);
    };
    const handleAuthorityReady = () => bindAuthority();
    const finishSubmitting = () => {
      submitting = false;
      button.removeAttribute('aria-busy');
      renderSnapshot(authority?.getSnapshot());
    };
    const handlePurchase = () => {
      if (submitting || !authority || !renderedSnapshot || button.disabled) return;

      const expectedRevision = renderedSnapshot.revision;
      submitting = true;
      applyButtonState(true, buttonLabel.textContent);
      let result;
      try {
        result = authority.activate(expectedRevision);
      } catch (error) {
        console.error('[desktop-purchase] activation failed', error);
        finishSubmitting();
        return;
      }
      if (!result?.ok) {
        finishSubmitting();
        return;
      }

      window.clearTimeout(submittingTimer);
      submittingTimer = window.setTimeout(finishSubmitting, 4000);
    };
    const activate = () => {
      if (active) return;
      active = true;
      button.addEventListener('click', handlePurchase);
      document.addEventListener('polypouch:purchasing-authority-ready', handleAuthorityReady);
      renderLoading();
      bindAuthority();
    };
    const deactivate = () => {
      if (!active) return;
      active = false;
      window.clearTimeout(submittingTimer);
      submitting = false;
      unsubscribe?.();
      unsubscribe = null;
      authority = null;
      button.removeEventListener('click', handlePurchase);
      document.removeEventListener('polypouch:purchasing-authority-ready', handleAuthorityReady);
      clearPresentation();
    };
    const handleBreakpoint = () => {
      if (desktopQuery.matches) activate();
      else deactivate();
    };
    const handleSectionUnload = (event) => {
      if (!event.target.contains(bar)) return;
      deactivate();
      desktopQuery.removeEventListener('change', handleBreakpoint);
      document.removeEventListener('shopify:section:unload', handleSectionUnload);
    };

    desktopQuery.addEventListener('change', handleBreakpoint);
    document.addEventListener('shopify:section:unload', handleSectionUnload);
    handleBreakpoint();
  })();
  } catch(e) { console.error(e); }
})();

})();
